export const deleteCookie = (name: string) => {
    const subDomainDot = process.env.NODE_ENV === 'production' ? '.' : ''
    document.cookie = `${name}=; expires=Thu, 01-Jan-70 00:00:01 GMT; path=/; domain=${subDomainDot}${window.location.hostname}; sameSite=strict;`
}

export const getCookie = (name: string): string | boolean | undefined => {
    let cookie: string | undefined = document.cookie

    if (!cookie) return false

    cookie = cookie.split(';').find(row => row.trim().startsWith(name))

    return cookie
        ? cookie.split('=')[1]
        : false
}

export const setDomainCookie = (val: string, name: string = 'auth', expiresInHours: number = 18): string => {
    const cookieExpires = new Date()
    cookieExpires.setHours(cookieExpires.getHours() + expiresInHours)

    const secure = process.env.NODE_ENV === 'production' ? ' secure' : ''
    const subDomainDot = process.env.NODE_ENV === 'production' ? '.' : ''

    return document.cookie =
        `${name}=${val}; expires=${cookieExpires}; domain=${subDomainDot}${window.location.hostname}; path=/; sameSite=strict;${secure}`
}
